import { render, staticRenderFns } from "./NominasImport.vue?vue&type=template&id=1209e3bb&"
import script from "./NominasImport.vue?vue&type=script&lang=js&"
export * from "./NominasImport.vue?vue&type=script&lang=js&"
import style0 from "./NominasImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports